<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kfcN9G/tc-custom/9780814740712.jpg?1705030461933" alt="This image is the cover for the book American Jesuits"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Jesuits
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Choice Outstanding Academic Title for 2008</b><br/><br/><b>A broad and compelling look at the impact of the largest Catholic order of men on American culture</b><br/><br/><br/>With infectious energy and a genuine gift for storytelling, Raymond A. Schroth recounts the history of Jesuits in the United States. <b>The American Jesuits</b> isn’t simply a book for Catholics; it’s for anyone who loves a well-told historical tale. For more than 450 years, Jesuit priests have traveled the globe out of a religious commitment to serve others. Their order, the Society of Jesus, is the largest religious order of men in the Catholic Church, with more than 20,000 members around the world and almost 3,000 in the United States. It is one of the more liberal orders in the Church, taking very public stands in the U.S. on behalf of social justice causes such as the promotion of immigrants’ rights and humanitarian aid, including assistance to Africa’s poor, and against American involvement in “unjust wars.” Jesuits have played an important part in Americanizing the Catholic Church and in preparing Catholic immigrants for inclusion into American society.<br/><br/>Starting off with the first Jesuit to reach the New World—he was promptly murdered on the Florida coast—Schroth focuses on the key periods of the Jesuit experience in the Americas, beginning with the era of European explorers, many of whom were accompanied by Jesuits and some of whom were Jesuits themselves. Suppressed around the time of the American Revolution, the Society experienced resurgence in the nineteenth century, arriving in the U.S. along with waves of Catholic immigrants and establishing a network of high schools and universities. In the mid-twentieth century, the Society transformed itself to serve an urbanizing nation.<br/><br/>Schroth is not blind to the Society’s shortcomings and not all of his story reflects well on the Jesuits. However, as he reminds readers, Jesuits are not gods and they don’t dwell in mountaintop monasteries. Rather, they are imperfect men who work in a messy world to “find God in all things” and to help their fellow men and women do the same.<br/>A quintessential American tale of men willing to take risks — for Indians, blacks, immigrants, and the poor, and to promote a loving picture of God—<b>The American Jesuits</b> offers a broad and compelling look at the impact of this 400-year-old international order on American culture and the culture’s impact on the Jesuits.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Raymond A Schroth
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ee46ed58